<template>
    <v-card>
        <v-container class="container" fluid>
            <v-toolbar dense dark color="secondary">
                <v-spacer />
                <v-toolbar-title class="white--text"
                    >Customer Rates</v-toolbar-title
                >
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-form ref="formCustomer" v-model="valid" lazy-validation>
                <v-row
                    justify="center"
                    style="margin-top: 0px;padding-top: 0px;"
                    class="mb-1"
                >
                    <v-col sm="12" md="3" lg="2">
                        <v-combobox
                            v-model="customer"
                            placeholder="Select Customer"
                            class="mx-3"
                            label="Customer"
                            :items="customers"
                            :rules="[v => !!v || 'Required']"
                            required
                            dense
                            hide-details
                            :item-text="'Name'"
                            :item-value="'id'"
                            auto-select-first
                            @change="rateCustomer"
                        ></v-combobox>
                    </v-col>
                    <v-col sm="12" md="3" lg="2">
                        <v-combobox
                            v-model="range"
                            placeholder="Select Range"
                            class="mx-3"
                            label="Range"
                            :items="ranges"
                            dense
                            hide-details
                            auto-select-first
                            :item-text="'Range'"
                            @change="loadRatesByRates"
                        >
                        </v-combobox>
                    </v-col>
                    <v-col sm="12" md="3" lg="2">
                        <input
                            type="file"
                            class="mt-2 float-left"
                            @change="readExcel"
                        />
                    </v-col>
                    <v-col>
                        <v-btn
                            cols="1"
                            color="primary"
                            class="mt-2 ml-12"
                            icon
                            @click="validate()"
                            ><v-icon>mdi-upload</v-icon></v-btn
                        >
                    </v-col>
                </v-row>
            </v-form>
            <v-container grid-list-xs fluid>
                <v-data-table :headers="headers" :items="CustomerRate" dense 
                fixed-header
                height="650px">
                </v-data-table>
            </v-container>
            <addRates
                v-if="$store.state.customerRate.add"
                :customer="customer.Name"
                :data="rates"
                :stations="stations"
                :terminals="terminals"
            ></addRates>
        </v-container>
    </v-card>
</template>

<script>
import addRates from './../Modals/Catalogs/CustomerRate/AddExcel.vue';
import axios from 'axios';
import * as XLSX from 'xlsx';
export default {
    name: 'Yards',
    components: {
        addRates
    },
    data: function() {
        return {
            valid: false,
            customers: [],
            customer: [],
            excel: null,
            data: [],
            stations: [],
            terminals: [],
            rates: [],
            CustomerRate: [],
            ranges: [],
            range: [],
            jsonData: null,
            headers: [
                { text: 'Terminal', value: 'Terminal', width: '20%' },
                { text: 'Station', value: 'Station', width: '20%' },
                { text: 'ShipTo', value: 'ShipTo' },
                { text: 'GasOldRate', value: 'GasOldRate' },
                { text: 'DiesOldRate', value: 'DiesOldRate' },
                { text: 'GasNewRate', value: 'GasNewRate' },
                { text: 'DiesNewRate', value: 'DiesNewRate' },
                { text: 'EffectiveFrom', value: 'EffectiveFrom' },
                { text: 'EffectiveTo', value: 'EffectiveTo' },
                { text: 'ShiptoName', value: 'ShiptoName', width: '20%' }
            ]
        };
    },

    computed: {
        formTitle() {
            return this.edited.id === 0 ? 'New Item' : 'Edit Item';
        }
    },

    watch: {
        dialog(val) {
            val || this.cancel();
        }
    },

    mounted() {
        this.loadCustomers();
        this.loadStations();
    },

    methods: {
        loadRatesByRates() {
            var parms = {
                Customer: this.customer.id,
                EffectiveFrom: this.range.EffectiveFrom,
                EffectiveTo: this.range.EffectiveTo
            };
            axios
                .post('customer-rate/ranges', parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.CustomerRate = response.data;
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        loadStations: function() {
            axios
                .get('station')
                .then(response => {
                    this.stations = response.data.data;
                    this.loadTerminals();
                    console.log(this.stations);
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        loadTerminals: function() {
            var str = this.$store;
            this.$store.state.isLoading = true;
            axios
                .get('terminal')
                .then(response => {
                    this.terminals = response.data.data;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        loadCustomers: function() {
            this.$store.state.isLoading = true;
            axios
                .get('customer/active')
                .then(response => {
                    console.log(response.data.data);
                    this.customers = response.data.data;
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        readExcel: async function(e) {
            console.log(e.target.files[0]);
            const file = e.target.files[0];
            const reader = new FileReader();

            reader.onload = e => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const worksheet = workbook.Sheets[workbook.SheetNames[0]];
                const jsonData = XLSX.utils.sheet_to_json(worksheet);
                this.jsonData = JSON.stringify(jsonData, null, 2);
            };

            reader.readAsArrayBuffer(file);
        },
        rateCustomer: function() {
            var str = this.$store;
            var parms = {
                Customer: this.customer.id
            };
            axios
                .post('customer-rate/rates', parms)
                .then(async response => {
                    this.CustomerRate = response.data['rates'];
                    this.ranges = response.data['range'].map(x => {
                        return {
                            EffectiveFrom: x.EffectiveFrom,
                            EffectiveTo: x.EffectiveTo,
                            Range: x.EffectiveFrom + '/' + x.EffectiveTo
                        };
                    });
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        validate() {
            var str = this.$store;
            if (this.customer.length == 0 || this.customer == null) {
                str.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'Select Customer Please.'
                });
            } else {
                this.sendExcel();
            }
        },
        sendExcel: function() {
            var str = this.$store;
            str.state.isLoading = true;
            var parms = {
                data: this.jsonData,
                StNumber: this.searchStatement
            };
            this.entries = null;
            axios
                .post('customer-rate/charge/excel', parms)
                .then(async response => {
                    this.data = response.data;
                    str.state.isLoading = false;
                    this.filterDuplicate();
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        filterDuplicate: function() {
            const distinct = {};
            var unique = [];
            for (const record of this.data) {
                const key = record['TEMRINAL ID'] + '-' + record['STATION ID'];
                if (!distinct[key]) {
                    distinct[key] = true;
                    unique.push({
                        Terminal: record['TEMRINAL ID'],
                        Station: record['STATION ID']
                    });
                }
            }
            this.loadDataExcel(unique);
        },
        loadDataExcel: async function(unique) {
            var parms = [];
            for (const elm of unique) {
                const clonedFilter = {};
                for (const xlsx of this.data) {
                    if (
                        elm.Terminal == xlsx['TEMRINAL ID'] &&
                        elm.Station == xlsx['STATION ID']
                    ) {
                        if (xlsx.Product == 'Mogas') {
                            clonedFilter.Customer = this.customer.id;
                            clonedFilter.Terminal = elm.Terminal;
                            clonedFilter.Station = elm.Station;
                            clonedFilter.ShipTo = xlsx.Shipto;
                            clonedFilter.GasOldRate = xlsx['Old Rate'];
                            clonedFilter.GasNewRate = xlsx['New Rate'];
                            clonedFilter.EffectiveFrom =
                                xlsx['New Effective from'];
                            clonedFilter.EffectiveTo = xlsx['New Effective to'];
                            clonedFilter.ShiptoName = xlsx['Ship to Name'];
                        } else {
                            clonedFilter.DiesOldRate = xlsx['Old Rate'];
                            clonedFilter.DiesNewRate = xlsx['New Rate'];
                        }
                    }
                }
                parms.push(clonedFilter);
            }
            this.rates = parms;
            this.$store.state.customerRate.add = true;
            console.log(parms);
        }
    }
};
</script>
